<template>
  <div>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <v-icon class="prepend-icon">search</v-icon>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getFinancials">搜尋</button>
      </div>

      <!-- table -->
      <div class="table">
        <div class="table-head">
          <!-- column head -->
          <div class="form-item d-flex px-5 h-60px align-center">
            <h5 class="col-year">年份</h5>
            <h5 class="col-edit ml-auto">編輯</h5>
            <h5 class="col-delete">刪除</h5>
          </div>
        </div>
        <div class="table-body">
          <div
            class="form-item d-flex h-60px align-center"
            v-for="item in financials"
            :key="item.id"
          >
            <div class="h5 col-year">{{ item.title }}</div>
            <div class="h5 col-edit ml-auto">
              <button class="btn square" @click="toEditFinancialInformation(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </div>
            <div class="h5 col-delete">
              <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
            </div>
          </div>
        </div>
      </div>

      <!-- table footer -->
      <Pagination @handleNextPreEvent="getFinancials" model="financial"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    deleteDialog,
    Pagination,
  },
  data: () => ({}),
  computed: {
    ...mapState('financial', ['financials', 'filter']),
    filterTableList() {
      const vm = this;
      return (
        this.tableList
          // textFilter
          .filter((item) =>
            String(item.year)
              .toLowerCase()
              .includes(vm.textFilter),
          )
      );
    },
    filterNumPerPageTableList() {
      const vm = this;
      return this.filterTableList.filter((item, i) => {
        if (vm.numberOfItemsPerPage === 'All') return true;
        return (
          i <= Number(vm.numberOfItemsPerPage) * vm.currentPage - 1 &&
          i >= Number(vm.numberOfItemsPerPage) * (vm.currentPage - 1)
        );
      });
    },
  },
  methods: {
    ...mapActions('financial', {
      getFinancials: 'find',
      destroyFinancial: 'destroy',
      clear: 'clear',
    }),
    toEditFinancialInformation(id) {
      this.$router.push({
        name: 'EditFinancialInformation',
        params: { id },
      });
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyFinancial(id).then(() => {
        this.getFinancials();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-year {
    width: 150px;
    margin-right: 20px;
  }

  .col-show {
    margin-right: 40px;
  }
}
</style>
